import { redirect } from '@/lib/router-adapter';

function encodedRedirect(
    type: 'error' | 'success',
    path: string,
    message: string,
) {
    return redirect(encodeRedirectionUrl(type, path, message));
}

function encodeRedirectionUrl(
    type: 'error' | 'success',
    path: string,
    message: string,
) {
    return `${path}?${type}=${encodeURIComponent(message)}`;
}

export const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.ogg', '.mov'] as const;

export function isVideoUrl(url: string): boolean {
    if (!url) return false;
    return VIDEO_EXTENSIONS.some((ext) => url?.toLowerCase().includes(ext));
}

export { encodedRedirect, encodeRedirectionUrl };
